import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { injectContext, PolymorpheusComponent } from '@taiga-ui/polymorpheus';

@Component({
  selector: 'app-recording-navigation-blocked-dialog',
  imports: [TuiButton],
  templateUrl: './recording-navigation-blocked-dialog.html',
  styleUrl: './recording-navigation-blocked-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecordingNavigationBlockedDialog {
  readonly context = injectContext<TuiDialogContext<boolean>>();

  dismiss(): void {
    this.context.completeWith(true);
  }
}

export const RECORDING_NAVIGATION_BLOCKED_DIALOG = new PolymorpheusComponent(
  RecordingNavigationBlockedDialog
);
